<!-- Author: Wilson Pilco Nunez -->
<!--  Email: wilsonaux1@gmail.com -->
<!--  Created at: 2023-05-05 19:25 -->
<!--  Description:  -->
<template>
  <div>
    <h4>DOCTORES</h4>
    <ul class="nav nav-tabs mb-3">
      <li class="nav-item">
        <a class="nav-link" @click="tab = 'doctors'; filter.den_odo_work = 1; filter.enable = 1;  $refs.tr.gl();"
          :class="{'active': tab == 'doctors'}">
          <i class="fa fa-user-md"></i> Doctores
        </a>  
      </li>
      <li class="nav-item">
        <a class="nav-link" @click="tab = 'employees'; filter.den_odo_work = 0; filter.enable = 1; $refs.tr.gl();"
          :class="{'active': tab == 'employees'}">
          <i class="fa fa-user"></i> Empleados
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" @click="tab = 'disabled'; filter.enable = 0; filter.den_odo_work = undefined; $refs.tr.gl();"
          :class="{'active': tab =='disabled'}">
          <i class="fa fa-ban"></i> Inhabilitados
        </a>
      </li>
    </ul>
    <app-table-registers ref="tr" :getList="getList" @btnNew="$router.push({name: 'dent.doctor-new'})">
      <template slot="table">
        <thead>
          <tr>
            <th>U. COD</th>
            <th>NOMBRE</th>
            <th>PORCENTAJE(%)</th>
            <th>INTERVALO DE ATENCION MIN</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="l in list.data" :key="l.id">
            <td>{{ l.id }}</td>
            <td>{{ l.name }}</td>
            <td>{{ l.portion_by_service | percent }}</td>
            <td>{{ l.schedule_interval }} min</td>
            <td>
              <button class="btn btn-light btn-sm" @click="enableNotifyConfirm(l)">
                <i class="fa-bell" :class="{'fas': l.notity, 'far': !l.notity}"></i>
              </button>
              <router-link class="btn btn-sm btn-light"
                  :to="{ 'name': 'dent.doctor-config', params: { id: l.id } }"> 
                <i class="fa fa-cog"></i>
              </router-link>
              <button class="btn btn-light btn-sm" @click="deleteItem(l)" v-show="l.enable">
                <i class="fas fa-trash"></i>
              </button>
              <button class="btn btn-light btn-sm" @click="undeleteItem(l)" v-show="!l.enable">
                <i class="fas fa-undo"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </template>
    </app-table-registers>

    <app-modal-basic ref="dConf">
      <FormConfig ref="formConf" @submitted="
        $refs.dConf.hide();
      $refs.tr.gl();
      "></FormConfig>
    </app-modal-basic>

    <app-modal-basic ref="dEmpHor" :xl="true">
      <h4>HORARIO</h4>
      <ScheduleManager ref="elScheduleManager"></ScheduleManager>
    </app-modal-basic>
  </div>
</template>
<script>
// script content
import {DentalClinicService} from "../service";
import ScheduleManager from "./ScheduleManager.vue";
import FormConfig from "../liquidations/Form.vue";
import QuoteNotify from "./QuoteNotify.js";
import {AdminService} from "src/admin-module/AdminService.js";
export default {
  name: "DoctorList",
  components: {
    FormConfig,
    ScheduleManager,
  },

  // directives

  props: {
    //
  },

  data: () => ({
    list: {},
    tab: 'doctors',
    employee_id: undefined,
    filter: {
      den_odo_work: 1,
      enable: 1,
    }
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    //
  },

  methods: {
    enableNotifyConfirm(doc) {
      window.Notification.requestPermission().then(() => {
        if (
          !doc.notity &&
          window.confirm("Activar notificaciones para citas 10 minutos antes en este dispositivo?")
        ) {
          QuoteNotify.addEmployeeId(doc.id);
          doc.notity = true;
          location.reload();
        } else {
          QuoteNotify.removeEmployee(doc.id);
          doc.notity = false;
        }
      })
    },
    getList(params) {
      return new Promise((rsv) => {
        let prev = QuoteNotify.getEmployeeNotifyList();
        AdminService.getEmployees({
          ...this.filter,
          ...params,
        }).then((res) => {
          res.data = res.data.map((x) => ({
            ...x,
            portion_by_service: x.portion_by_service ? x.portion_by_service : 0,
            interval_service: x.interval_service ? x.interval_service : 0,
            notity: prev.includes(x.id),
          }));
          this.list = res;
          rsv(res);
        });
      });
    },
    async deleteItem(item) {
      if(window.confirm("Eliminar este registro?")) {
        await AdminService.deleteEmployee(item.id);
        this.$refs.tr.gl();
      }
    },
    async undeleteItem(item) {
      if(window.confirm("Restaurar este registro?")) {
        await AdminService.saveEmployee({
          id: item.id,
          enable: 1,
        });
        this.$refs.tr.gl();
      }
    }
  },
};
</script>
<style scoped></style>
